module.exports = __webpack_public_path__ + "static/image/font/pc/bmhannaair-6@3x.ver2_0_2.jpg?e9a2a22c";